<template>
    <div class="tab-pane fade" id="account-details">
        <h3>Tài khoản</h3>
        <div class="login">
            <div class="login_form_container">
                <div class="account_login_form">
                    <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                        <v-flex lg12>
                            <h5>Tiền hàng: <b>{{ customer.total_amount | currency }}</b></h5>
                        </v-flex>
                        <v-flex lg12>
                            <h5>Trả hàng: <b>{{ customer.total_return | currency }}</b></h5>
                        </v-flex>
                        <v-flex lg12>
                            <h5>Thanh toán: <b>{{ customer.total_recharge | currency }}</b></h5>
                        </v-flex>
                        <v-flex lg12>
                            <h5>Công nợ: <b class="text-red">{{ customer.total_debt | currency }}</b></h5>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                            <hr />
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                            <h5><b>Đổi mật khẩu</b></h5>
                        </v-flex>
                        <v-flex lg4 md6 sm12>
                            <v-text-field v-model="password" type="password" label="Mật khẩu mới"
                                class="input-group--focused"></v-text-field>
                            <v-text-field v-model="retype_password" type="password" label="Nhập lại mật khẩu mới"
                                class="input-group--focused"></v-text-field>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-btn @click="changePassword">Cập nhật</v-btn>
                        </v-flex>
                    </v-layout>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from '@/configs'
import _ from 'lodash';
import { display_color } from "@/commons/formater";
import { pad } from '@/commons/utils'
export default {
    data () {
        return {
            pad: pad,
            display_color: display_color,
            password: '',
            retype_password: '',
            selectedItem: null,
            dialogItem: false
        }
    },
    computed: {
        ...mapState({
            customer: (state) => state.users.selected,
            loading: state => state.users.loading
        }),
        customer_id() {
            return this.$store.state.authentication.user.id;
        },
    },
    methods: {
        changePassword() {
            if(this.password != this.retype_password) {
                sendErrorNotice('Mật khẩu không khớp!');
                return;
            }
            if(this.password != '') {
                this.$store.dispatch("users/setDetail", {data: {'password': this.password}, id: this.$store.state.authentication.user.id});
            }
        },
    },
    mounted () {
        this.$store.dispatch("users/getDetail", this.customer_id);
        this.$root.$emit('COMPONENT_LOADED');
        this.$root.$off("REQUEST_REFRESH_DATA");
    },
}
</script>